import {
  AfterViewInit, Component, ElementRef, EventEmitter, inject, Input, OnDestroy, Output, signal, ViewChild
} from '@angular/core';
import {SearchContainer} from '../../../core/definitions/search-container';
import {MatChip, MatChipRemove, MatChipSet} from '@angular/material/chips';
import {MatIcon} from '@angular/material/icon';
import {SharedModule} from '../../../shared/shared.module';
import {SearchFilterService} from '../../search-filter.service';
import {MatButton} from '@angular/material/button';
import {FilterChip, searchContainerToChipList} from './searchContainerToChipList';
import {Subject, Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {SearchViewCategoryMenuService} from "../../search-view-category-menu.service";
import {SearchExecutorService} from '../../search-executor.service';

function chipEquals(a: FilterChip, b: FilterChip) {
  return a.key === b.key;
}

@Component({
    selector: 'app-search-filter-chiplist',
    imports: [MatChip, MatChipRemove, MatIcon, MatChipSet, SharedModule, MatButton],
    templateUrl: './search-filter-chiplist.component.html',
    styleUrl: './search-filter-chiplist.component.scss'
})
export class SearchFilterChiplistComponent implements OnDestroy, AfterViewInit {
  // Injections
  private readonly categoryMenuService: SearchViewCategoryMenuService = inject(SearchViewCategoryMenuService);
  private readonly searchExecutorService: SearchExecutorService = inject(SearchExecutorService);
  private readonly searchFilterService: SearchFilterService = inject(SearchFilterService);

  @Input() searchContainer!: SearchContainer;
  @Output() filterRemoved = new EventEmitter<void>();

  @ViewChild('scrollContainer') scrollContainer: ElementRef<HTMLDivElement>;

  chips = signal<FilterChip[]>([])
  private subscriptions: Subscription[] = [];

  private searchExecutorChanged$ = new Subject<void>();

  ngAfterViewInit() {
    this.searchExecutorService.subscribeToSearchResult(this.searchContainer, () => {
      this.searchExecutorChanged$.next();
    })

    this.updateChips();
    this.subscriptions.push(this.searchExecutorChanged$.pipe(debounceTime(100),).subscribe(() => {
      this.updateChips();
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  async onRemoveChipClick(chip: FilterChip) {
    await this.removeChip(chip);

    if (this.chips().length === 1) {
      //this.chips.set([]);
      this.searchFilterService.resetFilter(this.searchContainer);
    }

    this.filterRemoved.emit();
  }

  async onClearAllClick() {
    this.searchFilterService.resetFilter(this.searchContainer);
    // Keeping this in case it needs to rolled back to this.
    //await Promise.all(this.chips().map((chip) => this.removeChip(chip)))
    this.filterRemoved.emit();
  }

  private updateChips() {
    const oldChips = this.chips();
    // I did this, I think, I dont remember why it was this complicated or what could break by disabling it, but this is what was here before
    // if shit hits the fan
    /*this.categoryMenuService.getCategoryMenus(this.searchContainer.currentPathView.search_view.menus).then(categoryMenus => {
      const newChips = searchContainerToChipList(this.searchContainer, categoryMenus);
      const addedChips = newChips.filter((chip) => !oldChips.some((oldChip) => chipEquals(chip, oldChip)));
      const removedChips = oldChips.filter((chip) => !newChips.some((newChip) => chipEquals(chip, newChip)));
      this.chips.update(oldChips => oldChips
        .filter(
          (chip) => !removedChips.some((removedChip) => chipEquals(chip, removedChip))
        ).concat(addedChips).reverse()
      );

      setTimeout(() => {
        if (addedChips.length && this.scrollContainer) {
          this.scrollContainer.nativeElement.scrollTo({
            left: this.scrollContainer.nativeElement.scrollWidth, behavior: 'smooth'
          })
        }
      })
    })*/
    //Remove these three lines and uncomment the above code to revert old functionality
    this.categoryMenuService.getCategoryMenus(this.searchContainer.currentPathView.search_view.menus).then(categoryMenus => {
      this.chips.set(searchContainerToChipList(this.searchContainer, categoryMenus));
    })
  }

  private async removeChip(chip: FilterChip) {
    if (chip.type === "searchMenu") {
      await this.searchFilterService.checkMenuFilter(chip.menu, this.searchContainer, true);
    } else if (chip.type === "checkFilter") {
      await this.searchFilterService.checkCheckFilters([chip.filter], this.searchContainer, false, true);
    } else if (chip.type === "rangeFilter") {
      await this.searchFilterService.checkRangeFilter(chip.filterGroup, chip.filter, this.searchContainer);
    } else if (chip.type === 'hierarchicFilter') {
      chip.filter.facet.selected = false;
      chip.filter.open = false;
      this.searchContainer.filtersFacets.hierarchicFilterGroup.lastSelectedNode = null;
    }
  }
}
